<div class="component-main-container">
  <div class="header">
    <app-page-header
      pageTitle="{{ 'manage-user.pageTitle' | translate }}"
      parentTitle="{{ 'manage-user.parentTitle' | translate }}"
    ></app-page-header>
  </div>
  <!--Corpo do componente-->
  <div class="row">
    <div class="col-lg-4 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <!-- Box de criação de usuários -->
        <form
          class="form-fields-box"
          [ngClass]="!isCreateUser ? 'closed' : ''"
          [formGroup]="createUserForm"
        >
          <h2 (click)="createUserBox()">
            {{ "manage-user.create-form-title" | translate }}
          </h2>
          <hr [ngClass]="!isCreateUser ? 'hr-open' : ''" />

          <!-- Campo de nome -->
          <div class="form-step">
            <div class="circle-number">1</div>
            <div class="input-text">
              <p-floatlabel variant="on">
                <input
                  [class.p-invalid]="
                    createUserForm.get('firstNameCreateForm')?.invalid
                  "
                  pInputText
                  fluid
                  formControlName="firstNameCreateForm"
                  id="firstNameCreateForm"
                />
                <label for="firstNameCreateForm">
                  {{ "manage-user.name-create-form" | translate }}
                </label>
              </p-floatlabel>
            </div>
          </div>

          <!-- Campo de sobrenome -->
          <div class="form-step">
            <div class="circle-number">2</div>
            <div class="input-text">
              <p-floatlabel variant="on">
                <input
                  [class.p-invalid]="
                    createUserForm.get('lastNameCreateForm')?.invalid
                  "
                  pInputText
                  fluid
                  formControlName="lastNameCreateForm"
                  id="lastNameCreateForm"
                />
                <label for="lastNameCreateForm">
                  {{ "manage-user.last-name-create-form" | translate }}
                </label>
              </p-floatlabel>
            </div>
          </div>

          <!-- Campo de usuário -->
          <div class="form-step">
            <div class="circle-number">3</div>
            <div class="input-text">
              <p-floatlabel variant="on">
                <input
                  [class.p-invalid]="
                    createUserForm.get('usernameCreateForm')?.invalid
                  "
                  pInputText
                  fluid
                  formControlName="usernameCreateForm"
                  id="usernameCreateForm"
                />
                <label for="usernameCreateForm">
                  {{ "manage-user.user-create-form" | translate }}
                </label>
              </p-floatlabel>
            </div>
          </div>

          <!-- Campo de email -->
          <div class="form-step">
            <div class="circle-number">4</div>
            <div class="input-text">
              <p-floatlabel variant="on">
                <input
                  [class.p-invalid]="
                    createUserForm.get('emailCreateForm')?.invalid
                  "
                  pInputText
                  fluid
                  formControlName="emailCreateForm"
                  id="emailCreateForm"
                />
                <label for="emailCreateForm">
                  {{ "manage-user.email-create-form" | translate }}
                </label>
              </p-floatlabel>
            </div>
          </div>

          <!-- Campo de senha -->
          <div class="form-step">
            <div class="circle-number">5</div>
            <div class="input-text">
              <p-floatlabel variant="on">
                <input
                  [class.p-invalid]="
                    createUserForm.get('passwordCreateForm')?.invalid
                  "
                  pInputText
                  fluid
                  formControlName="passwordCreateForm"
                  id="passwordCreateForm"
                />
                <label for="passwordCreateForm">
                  {{ "manage-user.password-create-form" | translate }}
                </label>
              </p-floatlabel>
            </div>
          </div>

          <div style="list-style-type: none">
            @if (
              createUserForm.get("passwordCreateForm")?.hasError("minlength")
            ) {
              <li style="color: red">
                - {{ "manage-user.password-character-validator" | translate }}
              </li>
            }
            @if (
              createUserForm.get("passwordCreateForm")?.hasError("pattern")
            ) {
              <li class="mb-5" style="color: red">
                - {{ "manage-user.password-validatior" | translate }}
              </li>
            }
          </div>

          <!-- Campo de seleção de Empresas -->
          <div class="form-step">
            <div class="circle-number">6</div>
            <div class="input-text">
              <!-- Seleção de empresas  -->
              <p-floatlabel variant="on">
                @if (companyList.length) {
                  <p-multiselect
                    appendTo="body"
                    inputId="companies"
                    formControlName="companies"
                    [options]="companyList"
                    optionLabel="reference"
                    optionValue="id"
                    [showToggleAll]="false"
                    class="w-full"
                    emptyFilterMessage="Nenhum resultado encontrado"
                    emptyMessage="Nenhum resultado encontrado"
                    [selectedItemsLabel]="
                      'manage-user.selected-companies' | translate
                    "
                    selectionLimit="1"
                  >
                  </p-multiselect>
                }
                <label for="companies">
                  {{ "manage-user.select-company-edit" | translate }}
                </label>
              </p-floatlabel>
            </div>
          </div>

          <!-- Campo de seleção de Permissões -->
          <div class="form-step">
            <div class="circle-number">7</div>
            <div class="input-text">
              <!-- Seleção de permissões -->
              <p-floatlabel variant="on">
                @if (permissionList.length) {
                  <p-multiselect
                    appendTo="body"
                    inputId="permissions"
                    formControlName="permissions"
                    [options]="permissionList"
                    optionLabel="reference"
                    optionValue="id"
                    [showToggleAll]="true"
                    class="w-full"
                    emptyFilterMessage="Nenhum resultado encontrado"
                    emptyMessage="Nenhum resultado encontrado"
                    [selectedItemsLabel]="
                      'manage-user.selected-permissions' | translate
                    "
                  >
                  </p-multiselect>
                }

                <label for="permissions">
                  {{ "manage-user.select-permission-edit" | translate }}
                </label>
              </p-floatlabel>
            </div>
          </div>

          <!-- Campo de seleção de Grupos de Permissões -->
          <div class="form-step">
            <div class="circle-number">8</div>
            <!-- Seleção de permissões -->
            <div class="input-text">
              <p-floatlabel variant="on">
                @if (permissionGroupList.length) {
                  <p-multiselect
                    appendTo="body"
                    inputId="permissionsGroup"
                    formControlName="permissionsGroup"
                    [options]="permissionGroupList"
                    optionLabel="reference"
                    optionValue="id"
                    [showToggleAll]="true"
                    class="w-full"
                    emptyFilterMessage="Nenhum resultado encontrado"
                    emptyMessage="Nenhum resultado encontrado"
                    [selectedItemsLabel]="
                      'manage-user.selected-permissions' | translate
                    "
                  >
                  </p-multiselect>
                }

                <label for="permissionsGroup">
                  {{ "manage-user.select-permission-group-edit" | translate }}
                </label>
              </p-floatlabel>
            </div>
          </div>

          <!--Check box super usuário -->
          <div class="form-step">
            <div class="circle-number">9</div>
            <div class="input-text">
              <div class="flex flex-col">
                <div class="flex items-center gap-2">
                  <p-checkbox
                    inputId="isSuperUser"
                    [binary]="true"
                    formControlName="isSuperUser"
                  />
                  <label for="isSuperUser">
                    {{ "manage-user.create-form-super-user" | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          @if (!loadingCreateUser) {
            <button
              class="btn btn-success mb-2 w-100"
              (click)="createUser()"
              [disabled]="createUserForm.invalid"
            >
              {{ "manage-user.create-form-btn-success" | translate }}
            </button>
          }

          @if (!loadingCreateUser) {
            <button
              (click)="cancelCreateOrFilter()"
              type="button"
              class="btn btn-danger mb-2 w-100"
            >
              {{ "manage-user.create-form-btn-danger" | translate }}
            </button>
          }
          @if (loadingCreateUser) {
            <p-progress-spinner
              strokeWidth="8"
              fill="transparent"
              animationDuration=".5s"
              [style]="{ width: '50px', height: '50px' }"
            />
          }
        </form>

        <!-- Box para buscar usuário -->
        <div class="form-fields-box" [ngClass]="!isFilterUser ? 'closed' : ''">
          <h2 (click)="filterUserBox()">
            {{ "manage-user.filter-form-title" | translate }}
          </h2>
          <hr [ngClass]="!isFilterUser ? 'hr-open' : ''" />

          <form [formGroup]="filterForm">
            <!-- Campo de Usuário -->
            <div class="form-step">
              <div class="circle-number">1</div>
              <div class="input-text">
                <p-floatlabel variant="on">
                  <input
                    pInputText
                    fluid
                    formControlName="usernameContains"
                    id="usernameContains"
                  />
                  <label for="usernameContains">
                    {{ "manage-user.filter-form-user" | translate }}
                  </label>
                </p-floatlabel>
              </div>
            </div>

            <!-- Campo de email -->
            <div class="form-step">
              <div class="circle-number">2</div>
              <div class="input-text">
                <p-floatlabel variant="on">
                  <input
                    pInputText
                    fluid
                    formControlName="emailContains"
                    id="emailContains"
                  />
                  <label for="emailContains">
                    {{ "manage-user.filter-form-email" | translate }}
                  </label>
                </p-floatlabel>
              </div>
            </div>

            <!-- Campo de super usuário -->
            <div class="form-step">
              <div class="input-text">
                <div class="flex flex-col">
                  <div class="flex items-center gap-2">
                    <p-checkbox
                      inputId="isSuperUser"
                      [binary]="true"
                      formControlName="isSuperUser"
                    />
                    <label for="isSuperUser">
                      {{ "manage-user.filter-form-super-user" | translate }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex m-2">
              @if (!filterLoading) {
                <button
                  (click)="filterUser(null)"
                  class="btn btn-success mb-2 w-50"
                >
                  {{ "manage-user.filter-form-btn-success" | translate }}
                </button>
              }
              @if (!filterLoading) {
                <button
                  (click)="cancelCreateOrFilter()"
                  type="button"
                  class="btn btn-danger mb-2 w-50"
                >
                  {{ "manage-user.filter-form-btn-danger" | translate }}
                </button>
              }
              @if (filterLoading) {
                <p-progress-spinner
                  strokeWidth="8"
                  fill="transparent"
                  animationDuration=".5s"
                  [style]="{ width: '50px', height: '50px' }"
                />
              }
            </div>
          </form>
        </div>
      </div>
    </div>

    <!--Tabela-->
    @if (paginationProperties.total) {
      <div class="col-lg-8 col-xl-8 col-sm-12">
        <app-table-header
          [itensNumber]="paginationProperties.count"
          [totalNumber]="paginationProperties.total"
        >
        </app-table-header>
        <div class="table-container mt-2 mt-lg-3">
          <p-table
            [value]="ELEMENT_DATA"
            dataKey="id"
            [rows]="pageSize"
            [totalRecords]="length"
            [paginator]="true"
            (onPage)="pageChanged($event)"
            [showPageLinks]="false"
            [showFirstLastIcon]="false"
            [lazy]="true"
          >
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="name" style="width: 8rem">
                  {{ "manage-user.table-name" | translate }}
                </th>
                <th pSortableColumn="username" style="width: 5rem">
                  {{ "manage-user.table-username" | translate }}
                </th>
                <th pSortableColumn="email" style="width: 2rem">
                  {{ "manage-user.table-email" | translate }}
                </th>
                <th pSortableColumn="lastaccess" style="width: 5rem">
                  {{ "manage-user.table-lastaccess" | translate }}
                </th>
                <th pSortableColumn="superuser" style="width: 5rem">
                  {{ "manage-user.table-super-user" | translate }}
                </th>
                <th pSortableColumn="isactive" style="width: 5rem">
                  {{ "manage-user.user-is-active" | translate }}
                </th>
                <th pSortableColumn="actions" style="width: 10rem">
                  {{ "manage-user.table-user-data" | translate }}
                </th>
              </tr>
            </ng-template>
            <ng-template
              pTemplate="body"
              let-row
              let-columns="columns"
              let-ri="rowIndex"
            >
              <tr>
                <td>{{ row.name }}</td>
                <td>{{ row.username }}</td>
                <td>{{ row.email }}</td>
                <td>
                  <span
                    matTooltip="{{ 'time-zone-information-label' | translate }}"
                    matTooltipPosition="above"
                  >
                    {{ row.lastLogin }}
                  </span>
                </td>
                <td>
                  @if (row.superuser) {
                    <mat-icon svgIcon="bx-check"></mat-icon>
                  }
                </td>
                <td>
                  @if (row.isActive) {
                    <mat-icon svgIcon="bx-check"></mat-icon>
                  }
                </td>
                <td>
                  <p-button
                    styleClass="btn-actions"
                    (click)="OpenSidebarUpdate(row, false)"
                    icon="pi pi-user-edit"
                    [rounded]="true"
                  />

                  <p-button
                    styleClass="btn-view"
                    (click)="OpenSidebarUpdate(row, true)"
                    icon="pi pi-eye"
                    [rounded]="true"
                  />
                  @if (canResetMfa && row.mfaEnabled) {
                    <p-button
                      styleClass="btn-reset-mfa"
                      (click)="openResetMfa(row)"
                      icon="pi pi-shield"
                      [rounded]="true"
                      matTooltip="{{
                        'manage-user.reset-mfa-tooltip' | translate
                      }}"
                      matTooltipPosition="above"
                    />
                  }
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    }

    <!-- Componente de edição -->
    @if (isUpdateUser) {
      <p-drawer
        [(visible)]="isUpdateUser"
        position="right"
        [style]="{ width: '430px' }"
        [modal]="false"
      >
        <ng-template #header>
          <div class="w-full pt-6">
            <div class="flex flex-col items-center gap-2">
              <i
                class="pi pi-user-edit text-[#008e58]"
                style="font-size: 40px"
              ></i>
              <h2 class="m-0 font-semibold">
                {{ editTitle | translate }}
              </h2>
            </div>
          </div>
        </ng-template>
        <div class="flex h-full flex-col p-2">
          <div class="flex-1 p-4">
            <form [formGroup]="updateUserForm" class="flex flex-col gap-4">
              <p-floatlabel variant="on">
                <input
                  pInputText
                  class="w-full"
                  id="firstName"
                  formControlName="firstNameUpdateForm"
                  autocomplete="off"
                />
                <label for="firstName">
                  {{ "manage-user.name-form-edit" | translate }}
                </label>
              </p-floatlabel>

              <p-floatlabel variant="on">
                <input
                  pInputText
                  class="w-full"
                  id="lastName"
                  formControlName="lastNameUpdateForm"
                />
                <label for="lastName">
                  {{ "manage-user.last-name-form-edit" | translate }}
                </label>
              </p-floatlabel>

              <p-floatlabel variant="on">
                <input
                  pInputText
                  class="w-full"
                  id="username"
                  formControlName="userNameUpdateForm"
                />
                <label for="username">
                  {{ "manage-user.user-form-edit" | translate }}
                </label>
              </p-floatlabel>

              <p-floatlabel variant="on">
                <input
                  pInputText
                  class="w-full"
                  id="email"
                  formControlName="emailUpdateForm"
                />
                <label for="email">
                  {{ "manage-user.email-form-edit" | translate }}
                </label>
              </p-floatlabel>

              <p-floatlabel variant="on">
                <input
                  pInputText
                  class="w-full"
                  id="password"
                  formControlName="passwordUpdateForm"
                />
                <label for="password">
                  {{ "manage-user.password-form-edit" | translate }}
                </label>
              </p-floatlabel>

              @if (
                updateUserForm
                  .get("passwordUpdateForm")
                  ?.hasError("minlength") ||
                updateUserForm.get("passwordUpdateForm")?.hasError("pattern")
              ) {
                <div
                  style="align-self: start !important; list-style-type: none"
                >
                  @if (
                    updateUserForm
                      .get("passwordUpdateForm")
                      ?.hasError("minlength")
                  ) {
                    <li style="color: red">
                      -
                      {{
                        "manage-user.password-character-validator" | translate
                      }}
                    </li>
                  }
                  @if (
                    updateUserForm
                      .get("passwordUpdateForm")
                      ?.hasError("pattern")
                  ) {
                    <li style="color: red">
                      - {{ "manage-user.password-validatior" | translate }}
                    </li>
                  }
                </div>
              }

              <!-- Checkbox de super usário e usuário ativo -->
              <div class="flex flex-col gap-2">
                <div class="flex items-center gap-2">
                  <p-checkbox
                    inputId="superuser"
                    [binary]="true"
                    formControlName="superUserUpdateForm"
                  />
                  <label for="superuser">
                    {{ "manage-user.super-user-edit" | translate }}
                  </label>
                </div>
                <div class="flex items-center gap-2">
                  <p-checkbox
                    inputId="activeUser"
                    [binary]="true"
                    formControlName="isactiveUserUpdateForm"
                  />
                  <label for="activeUser">
                    {{ "manage-user.active-user-edit" | translate }}
                  </label>
                </div>
              </div>
              <!-- Seleção de empresas  -->
              <p-floatlabel variant="on">
                <p-multiselect
                  appendTo="body"
                  inputId="companies"
                  formControlName="companies"
                  [options]="companyListUpdate"
                  optionLabel="reference"
                  optionValue="id"
                  optionDisabled="disabled"
                  [showToggleAll]="false"
                  class="w-full"
                  (onChange)="updateCompanyOptions()"
                  emptyFilterMessage="Nenhum resultado encontrado"
                  emptyMessage="Nenhum resultado encontrado"
                  [selectedItemsLabel]="
                    'manage-user.selected-companies' | translate
                  "
                >
                </p-multiselect>

                <label for="companies">
                  {{ "manage-user.select-company-edit" | translate }}
                </label>
              </p-floatlabel>

              <!-- Seleção de permissões  -->
              <p-floatlabel variant="on">
                <p-multiselect
                  appendTo="body"
                  inputId="permissions"
                  formControlName="permissions"
                  [options]="permissionListUpdate"
                  optionLabel="reference"
                  optionValue="id"
                  optionDisabled="disabled"
                  [showToggleAll]="true"
                  class="w-full"
                  emptyFilterMessage="Nenhum resultado encontrado"
                  emptyMessage="Nenhum resultado encontrado"
                  [selectedItemsLabel]="
                    'manage-user.selected-permissions' | translate
                  "
                >
                </p-multiselect>

                <label for="permissions">
                  {{ "manage-user.select-permission-edit" | translate }}
                </label>
              </p-floatlabel>

              <!-- Seleção de grupos de permissões  -->
              <p-floatlabel variant="on">
                <p-multiselect
                  appendTo="body"
                  inputId="permissionsGroup"
                  [options]="permissionGroupListUpdate"
                  formControlName="permissionsGroup"
                  optionLabel="reference"
                  optionValue="id"
                  optionDisabled="disabled"
                  [showToggleAll]="true"
                  class="w-full"
                  emptyFilterMessage="Nenhum resultado encontrado"
                  emptyMessage="Nenhum resultado encontrado"
                  [selectedItemsLabel]="
                    'manage-user.selected-permissions-groups' | translate
                  "
                >
                </p-multiselect>

                <label for="permissionsGroup">
                  {{ "manage-user.select-permission-group-edit" | translate }}
                </label>
              </p-floatlabel>
            </form>

            <div class="p-4">
              <div class="flex justify-center gap-2">
                @if (!loadingUpdateUser && !viewController) {
                  <p-button
                    label="Cancelar"
                    severity="secondary"
                    (click)="isUpdateUser = false"
                  >
                  </p-button>
                  <p-button
                    [label]="'manage-user.button-save-edit' | translate"
                    (click)="updateUser()"
                  >
                  </p-button>
                }
                @if (loadingUpdateUser) {
                  <p-progress-spinner
                    strokeWidth="8"
                    fill="transparent"
                    animationDuration=".5s"
                    [style]="{ width: '50px', height: '50px' }"
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </p-drawer>
    }
    <!-- Modal de confirmação: reset do 2FA -->
    <p-dialog
      [(visible)]="isResetMfaDialogOpen"
      [modal]="true"
      [closable]="!loadingResetMfa"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '34rem' }"
      [breakpoints]="{ '960px': '75vw', '640px': '95vw' }"
      [header]="'manage-user.reset-mfa-title' | translate"
      styleClass="reset-mfa-dialog"
      (onHide)="resetMfaTarget = null"
    >
      <div class="reset-mfa-content">
        <p>
          {{
            "manage-user.reset-mfa-text"
              | translate: { username: resetMfaTarget?.username }
          }}
        </p>

        <ul>
          <li>{{ "manage-user.reset-mfa-effect-disable" | translate }}</li>
          <li>{{ "manage-user.reset-mfa-effect-codes" | translate }}</li>
          <li>{{ "manage-user.reset-mfa-effect-login" | translate }}</li>
        </ul>

        <div class="reset-mfa-warning">
          <i class="pi pi-exclamation-triangle"></i>
          <span>{{ "manage-user.reset-mfa-warning" | translate }}</span>
        </div>
      </div>

      <ng-template pTemplate="footer">
        <div class="flex justify-center gap-2">
          <p-button
            [label]="'manage-user.reset-mfa-cancel' | translate"
            severity="secondary"
            [disabled]="loadingResetMfa"
            (onClick)="closeResetMfa()"
          />
          <p-button
            [label]="'manage-user.reset-mfa-confirm' | translate"
            icon="pi pi-shield"
            severity="danger"
            [loading]="loadingResetMfa"
            (onClick)="confirmResetMfa()"
          />
        </div>
      </ng-template>
    </p-dialog>
  </div>
</div>
